import React from "react";
import { formatMoney } from "utils";

const OpenCloseBalance = ({ type, sum }) => {
  return (
    <div className="row align-items-center border-bottom border-1 mx-0">
      <div className="col-4 col-md-3 col-sm-4 py-3 text-end pe-0">
        <div className="fs-xmd-smaller fst-italic text-nowrap">
          {formatMoney(sum)}
        </div>
      </div>
      <div className="col-8 col-md-9 col-sm-8 ps-4 text-md-start text-end">
        <b className="fs-6">
          {type == "open" ? "Open Balance" : "Close Balance"}
        </b>
      </div>
    </div>
  )
}

export default OpenCloseBalance;
